import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// project-imports
import HeaderSticky from './HeaderSticky';
import ResponsiveMenu from './ResponsiveMenu';
import NavLandingDemo from './NavLandingDemo';
import ToolTip from '../Tooltip/ToolTip';
import { SupportUsForm } from '../../components/course/SupportUsForm';
import { useUserContext } from '../../context/user_context';
import AvatarDropDown from './AvatarDropDown';
import CalendlyPopupButton from '../../components/calendly/CalendlyPopupButton';
import { NotifyBar } from '../Notify/NotifyBar';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import LoginDropDown from './HeaderLoginDropDown';

// Reading Env variables
const SHOW_PRODUCT_OFFER = process.env.REACT_APP_SHOW_PRODUCT_OFFER_STRIPE;
const SHOW_EBOOK_OFFER = process.env.REACT_APP_SHOW_EBOOK_OFFER_STRIPE;
const END_DATE_OFFERINGS = process.env.REACT_APP_PRODUCTS_OFFER_END_DATE;
const END_DATE_EBOOK = process.env.REACT_APP_EBOOK_OFFER_END_DATE;
const OFFER_DESCRIPTION_PRODUCTS = process.env.REACT_APP_PRODUCTS_OFFER_DESCRIPTION;
const OFFER_DESCRIPTION_EBOOKS = process.env.REACT_APP_EBOOK_OFFER_DESCRIPTION;

const HeaderTwo = ({ styles, disableSticky, searchDisable, buttonStyle, isHomePage }) => {

    // reading context methods and variables
    const { loginData } = useUserContext();

    // Local State initialization
    const [offcanvasShow, setOffcanvasShow] = useState(false);
    const [searchPopup, setSearchPopup] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isOfferValid, setIsOfferValid] = useState({ products: false, ebooks: false });

    // Constant variables
    const member = loginData ? loginData.data : null;
    const sticky = HeaderSticky(200);
    const classes = `header-default ${sticky ? 'sticky' : ''}`;
    const stickyStatus = disableSticky ? '' : ' header-sticky';
    const isResponsive = offcanvasShow;

    // Constant functions

    const isOfferAvailable = () => {
        try {
            const today = new Date().setHours(0, 0, 0, 0);
            const offeringEndDate = new Date(END_DATE_OFFERINGS).setHours(0, 0, 0, 0);
            const ebookEndDate = new Date(END_DATE_EBOOK).setHours(0, 0, 0, 0);
            if (today <= offeringEndDate) {
                setIsOfferValid((prev) => ({ ...prev, products: true }));
            }
            if (today <= ebookEndDate) {
                setIsOfferValid((prev) => ({ ...prev, ebooks: true }));
            }
        } catch (error) {
            console.log("52 : HeaderTwo : Error in isOfferAvailable : ", error && JSON.stringify(error))
        }
    }

    const onCanvasHandler = () => {
        setOffcanvasShow(prevState => !prevState);
    }

    const onSearchHandler = () => {
        setSearchPopup(prevState => !prevState);
    }

    const onClickSupportForm = () => {
        triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SUPPORT_FORM_VIEW);
        setShowModal(true);
    }

    const onCloseSupportForm = () => {
        triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SUPPORT_FORM_CLOSE);
        setShowModal(false);
    }

    useEffect(() => {
        isOfferAvailable();
    }, []);

    // Conditional rendering for search popup
    if (searchPopup) {
        document.body.classList.add('search-popup-active');
    } else {
        document.body.classList.remove('search-popup-active');
    }

    return (
        <>
            <header className={`edu-header container-sm ${stickyStatus} ${styles || ''} ${classes || ''}`}>
                <div className="row align-items-center">
                    <div className='col-12 p-0'>
                        {isOfferValid?.products && SHOW_PRODUCT_OFFER === "true" &&
                            <NotifyBar endDate={END_DATE_OFFERINGS} description={OFFER_DESCRIPTION_PRODUCTS} btnName={"Enroll Now"} btnUrl={`/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}`} />
                        }
                        {isOfferValid?.ebooks && SHOW_EBOOK_OFFER === "true" &&
                            <NotifyBar endDate={END_DATE_EBOOK} description={OFFER_DESCRIPTION_EBOOKS} btnName={"Download Now"} btnUrl='/our-resources/paid' barClass='notify-bar' />
                        }
                    </div>
                    <div className="col-lg-4 col-xxl-2 col-md-6 col-4">
                        <div className="logo">
                            <Link to={process.env.PUBLIC_URL + "/"}>
                                <img className="logo-light object-fit-contain p-4" src="/images/logo/lsa-long-logo.png" alt="Main Logo" />
                            </Link>
                        </div>
                    </div>

                    {/* added the grid column -mit 8/12/25*/}
                    <div className="col-lg-6 col-xxl-7 d-none d-xxl-block">
                        <nav className="mainmenu-nav">
                            <NavLandingDemo
                                isHomePage={isHomePage}
                                checkResponsive={isResponsive}
                            />
                        </nav>
                    </div>

                    <div className="col-lg-8 col-xxl-3 col-md-6 col-8">
                        <div className="header-right d-flex justify-content-end">
                            <div className="header-menu-bar d-flex align-items-center">
                                {!searchDisable &&
                                    <div className="quote-icon quote-search">
                                        <button className="white-box-icon search-trigger header-search" onClick={onSearchHandler}>
                                            <i className="ri-search-line"></i>
                                        </button>
                                    </div>
                                }
                                {/* <ToolTip title="Keep Learning" id="t-1"><Link to={"/pricing"} className="white-box-hover-icon fs-2 ml--15 ml_sm--5"><IoCartOutline /></Link></ToolTip>
                                <ToolTip title="Support Us" id="t-1"><button variant="outline-light" onClick={onClickSupportForm} className="white-box-bordered-icon fs-2 ml--15 ml_sm--5"><BiDonateHeart /></button></ToolTip> */}
                                {/* <ToolTip title="Watch Us" id="t-4">
                                    <div className="youtube">
                                        <Link className="white-box-icon youtube-button header-menu shadow-none" to={process.env.REACT_APP_YOUTUBE_CHANNEL_URL} target="_blank">
                                            <i class="ri-youtube-fill"></i>
                                        </Link>
                                    </div>
                                </ToolTip> */}
                                
                               {/* <ToolTip title="Continue Shopping" id="t-1">
                                    <div className="carts">
                                        <Link className="white-box-icon carts-button header-menu shadow-none" to={`/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}`}>
                                            <i className="ri-shopping-cart-line"></i>
                                        </Link>
                                    </div>
                                </ToolTip> */}
                                {member && member?.userRecordId && (
                                    <ToolTip title="My Orders" id="t-1">
                                        <div className="carts">
                                            <Link className="white-box-icon carts-button header-menu shadow-none" to={`/user-details/${member?.userRecordId}#orders`}>
                                                <i className="ri-shopping-cart-line"></i>
                                            </Link>
                                        </div>
                                    </ToolTip>
                                )}

                                <ToolTip title="Support Us" id="t-2">
                                    <div className="support-us">
                                        <Link className="white-box-icon support-us-button header-menu shadow-none" onClick={onClickSupportForm}>
                                            <i className="ri-hand-heart-line"></i>
                                        </Link>
                                    </div>
                                </ToolTip>

                                <ToolTip title="E-Books" id="t-3">
                                    <div className="support-us">
                                        <Link to={'/our-resources/paid'} className="white-box-icon support-us-button header-menu shadow-none">
                                            <i class="ri-git-repository-line"></i>
                                        </Link>
                                    </div>
                                </ToolTip>
                                {/* TODO: 08012026 - Chnaged d-xxl-block to d-custom-block for YouTube icon button responsive issue | Longswitch Front-End Team */}
                                <div className="session d-none d-custom-block space-no-wrap">

                                    {/* TODO: 13012026 - Added the new route of Book Consultation instead of the Calendly Btn | Longswitch Front-End Team */}
                                    {/* TODO: 02022026 - Commented the newly Added route of Book Consultation | Longswitch Front-End Team */}
                                    <CalendlyPopupButton btnText="Book 1:1 Consultation" color='#F86F03' className='edu-btn subscribe btn-medium' />
                                    {/* <Link to={process.env.PUBLIC_URL + "/get-free-consultation"}
                                        onClick={() =>
                                            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.ABOUT_US_PAGE_CHOOSE_GUIDENCE_EXPLORE_COURSES)}
                                        className="edu-btn subscribe btn-medium fs-4" rel="noreferrer">
                                        Get Free Consultation
                                    </Link> */}
                                </div>

                                {/* TODO: 08012026 - Chnaged d-xl-block to d-xxl-block for YouTube icon button responsive issue | Longswitch Front-End Team */}
                                {member && member?.userId ?
                                    < div className="quote-icon quote-user d-none d-custom-block ml--15 ml_sm--5">
                                        <AvatarDropDown isLoggedIn={member && member.userId} member={member} />
                                    </div>
                                    :
                                    <>
                                        {/* TODO: 08012026 - Chnaged d-xxl-block to d-custom-block for YouTube icon button responsive issue | Longswitch Front-End Team */}
                                        <div className="quote-icon quote-user d-none d-custom-block ml--15 ml_sm--5">
                                            {/* <Link className={`edu-btn btn-medium left-icon header-button login ${buttonStyle || ''}`} to={process.env.PUBLIC_URL + "/login"}>
                                                Login
                                            </Link> */}
                                            {/* TODO: 24042026 - Chnaged from the login button to the drop down to show both login and register so user can get both option at one place */}
                                            <LoginDropDown isLoggedIn={member && member.userId} member={member} buttonStyle={buttonStyle} />
                                        </div>
                                    </>
                                }
                                {/* <div className="quote-icon quote-user d-block d-md-none ml--15 ml_sm--5">
                                    <Link to={process.env.PUBLIC_URL + "/login-register"} className="white-box-icon" href="#"><i className="ri-user-line"></i></Link>
                                </div> */}
                            </div>
                            {/* TODO: 08012026 - Chnaged d-xxl-none to d-custom-none for YouTube icon button responsive issue | Longswitch Front-End Team */}
                            <div className="mobile-menu-bar ml--15 ml_sm--5 d-block d-custom-none">
                                <div className="hamberger">
                                    <button className="white-box-icon hamberger-button header-menu" onClick={onCanvasHandler}>
                                        <i className="ri-menu-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header >
            <ResponsiveMenu
                show={offcanvasShow}
                onClose={onCanvasHandler}
                showSearch={searchPopup}
                onSearch={onSearchHandler}
                isLoggedIn={member && member?.userId && member}
                checkResponsive={isResponsive}
            />
            <SupportUsForm show={showModal} onCloseModal={onCloseSupportForm} title={"Support us"} />
        </>
    )
}

export default HeaderTwo;